/**
 * CP-15.3 + CP-15.4 — Three marketplace shells around the shared CrewShapeSearch.
 *
 * Each shell pins the marketplace code so the underlying matcher applies the
 * corresponding visibility rules + label overrides. Phase-12 ranking and the
 * Workforce Offering model are unchanged.
 *
 * CP-15.4 — the shell header text is no longer hard-coded. It is pulled live
 * from `GET /api/v1/marketplaces` so the admin Marketplaces tab can edit the
 * display name + description + nav label without a code change. Operator rule
 * §1 ("No hard-coded terminology") satisfied. While the API call is in flight
 * we fall back to neutral placeholders, never to canned product names.
 */
import React, { useEffect, useState } from "react";
import CrewShapeSearch from "@/pages/CrewShapeSearch";
import { api } from "@/lib/api";

function MarketplaceShell({ code }) {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api("/marketplaces");
        if (cancelled) return;
        const row = (r.items || []).find((m) => m.code === code);
        setMeta(row || null);
      } catch {
        setMeta(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <CrewShapeSearch
      marketplace={code}
      headerTitle={meta?.display_name || ""}
      headerDescription={meta?.description || ""}
    />
  );
}

export const IntegratorMarketplace = () => <MarketplaceShell code="integrator" />;
export const WorkforceMarketplace = () => <MarketplaceShell code="workforce" />;
export const EventTechMarketplace = () => <MarketplaceShell code="event_tech" />;
